import React from 'react';
import PropTypes from 'prop-types';
import {Card, Col, Form, Row} from 'antd';
import s from './Message.css';
import SendForm from './SendForm';

const WrappedSendForm = Form.create()(SendForm);

class Message extends React.Component {
  static propTypes = {
    locale: PropTypes.string.isRequired,
    numbers: PropTypes.arrayOf(PropTypes.string),
  };

  render() {
    return (
        <Row gutter={{ xs: 0, sm: 0, md: 0, lg: 100, xl: 100}}>
            <Col xs={24} sm={24} md={24} lg={24} xl={16}>
                <div>
                    <h1>{this.props.locale.title}</h1>
                    <WrappedSendForm locale={this.props.locale} numbers={this.props.numbers} />
                </div>
            </Col>
            <Col xs={24} sm={24} md={24} lg={24} xl={8} style={{marginTop:120}}>
                <Card style={{backgroundColor:"#f8f8f8"}} align="middle">
                    <p style={{fontWeight:"bold", fontSize:14}}>{this.props.locale.multiMessageGuidelinesTitle}</p>
                    <p style={{fontSize:14}}>{this.props.locale.multiMessageGuidelines1}.</p>
                    <p style={{fontSize:14}}>{this.props.locale.multiMessageGuidelines2}</p>
                </Card>
            </Col>
        </Row>
    );
  }
}

export default Message;




// WEBPACK FOOTER //
// ./src/routes/message/Message.js